var router = require('pjax').Router;
var index = require('./index.js');
var fieldForm = require('./form.js');

router.get('judging/scoring-criteria/:any', fieldForm);
router.get('judging/scoring-criteria', index);
